import React from 'react'
import { Button as CHButton } from 'components/Button/Button'

import { DropdownMenu } from '../DropdownMenu/DropdownMenu'

import { useSelector } from 'react-redux'
import { getUserLoggedInState } from '../../redux/reducers/users'

import events, { Event } from 'pubsub/events'
import { useTranslation } from 'react-i18next'

type Link = {
  id: string;
  label: string;
  href: string;
  isMbpRedirect?: boolean
}

interface NavSectionProps {
  analyticsCategory: string;
  description?: string;
  label: string;
  links: Link[];
  menuName: string;
}

const NavSection: React.FC<NavSectionProps> = ({ description, label, links, menuName, analyticsCategory }) => {
  const isLoggedIn = useSelector(getUserLoggedInState)
  const { i18n } = useTranslation('')

  const sendClickEvent = (link: Link) => {
    const options: Event = {
      text: link.label,
      authenticated: isLoggedIn,
      targetLocation: link.href,
      subheading: label,
      heading: menuName,
      category: analyticsCategory,
      activity: 'Link Click',
      url: window.location.href,
      language: i18n.language,
      title: document.title,
      sendToTealium: true,
      sendToCoreAPI: true,
      isMessageCenter: false
    }

    events.publish(options)
  }

  return (
    <li className='ch-c-resource-dropdown__link-section ds-u-sans'>
      <h2 className='ch-c-resource-dropdown__section-label'>{label}</h2>
      {
        description && <div className='ch-c-resource-dropdown__section-description ds-text-body--lg'>{description}</div>
      }
      <ul className='ch-c-resource-dropdown__link-list'>
        {links.map(link => (
          <li key={link.id}>
            <CHButton isMbpRedirect={link.isMbpRedirect} className='ch-c-link ds-c-button--transparent ch-u-p--0 ds-u-text-align--left ds-u-color--primary ch-u-text-decoration-none ch-u-text-hover-underline' href={link.href} onClick={() => sendClickEvent(link)}>{link.label}</CHButton>
          </li>)
        )}
      </ul>
    </li>
  )
}

export interface ResourceNavDropdownProps {
  analyticsCategory: string;
  name: string;
  sections: any[];
}

export const ResourceNavDropdown: React.FC<ResourceNavDropdownProps> = ({ analyticsCategory, name, sections }) => {
  return (
    <DropdownMenu className='ch-c-resource-dropdown'>
      <ul className='ch-c-resource-dropdown ch-c-resource-dropdown_508_padding ch-u-list-style-type--none'>
        {sections.map(section => (
          <NavSection
            analyticsCategory={analyticsCategory}
            key={section.id}
            menuName={name}
            description={section.description}
            label={section.label}
            links={section.links}
          />))}
      </ul>
    </DropdownMenu>
  )
}
